interface ApiSerializedError {
  message: string;
  status?: number;
  data?: unknown;
  url?: string;
  method?: string;
}

/**
 * Type guard matching the plain object thrown by ApiClient's request handler.
 * Distinguishes API failures from raw Error / primitive throws in epic `catchError` callbacks.
 */
export const isApiSerializedError = (value: unknown): value is ApiSerializedError => {
  if (typeof value !== 'object' || value === null) return false;
  const candidate = value as Record<string, unknown>;
  return typeof candidate.message === 'string' && typeof candidate.method === 'string';
};
